import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Paper, Typography, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Autocomplete, CircularProgress, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getRequest, postRequest } from '../../globalhelper/helper';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../redux/Common/commonActions';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Test_Script_Creation = () => {
    const [company, setCompany] = useState("");
    const [companies, setCompanies] = useState([]);
    const [fileContent, setfileContent] = useState('');
    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState('')
    const [openProcessConfirm, setOpenProcessConfirm] = useState(false);
    const [scriptDetails, setScriptDetails] = useState('');
    const [testCase, setTestCase] = useState('');
    const [loading, setLoading] = useState(false);

    let dispatch = useDispatch();

    useEffect(() => {
        getRequest(`api/edureka/getCompanyAssignedToUser`)
            .then((response) => {
                const responseData = response.res.data;
                setCompanies(responseData);
                if (responseData.length === 1) {
                    setCompany(responseData[0]);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name.replace(/\.[^/.]+$/, ""));
            setFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setfileContent(e.target.result);
            };
            reader.readAsText(file);
        }
        // Reset input so the same file can be selected again if deleted
        event.target.value = null;
    };

    const handleDelete = () => {
        setfileContent('');
        setFileName('');
        setScriptDetails('');
        setTestCase('');
    };

    const handleDownload = (content, defaultFilename) => {
        if (!content) return;
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        console.log(fileName, defaultFilename);
        link.download = fileName !== '' ? `${defaultFilename} of ${fileName.split('.')[0]}` : `${fileName}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handleProcessClick = () => {

        setOpenProcessConfirm(true);
    };

    const handleConfirmProcess = async () => {
        try {
            setLoading(true);
            dispatch(showLoader());
            const formData = new FormData();
            formData.append("file", file);
            const { res } = await postRequest(`api/upload/testScriptCreation?OrgID=${company.orgid}&KEY=testScript`, formData);
            console.log("Processing content:", res);
            if (res?.data) {
                if (res.data.testScenario) {
                    setScriptDetails(res.data.testScenario);
                }
                if (res.data.testCase) {
                    setTestCase(res.data.testCase);
                }
            }
            setOpenProcessConfirm(false);
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(hideLoader());
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={1} sm={2} md={3}>
                        <Autocomplete
                            options={companies || []}
                            value={company}
                            onChange={(e, newValue) => setCompany(newValue)}
                            getOptionLabel={(option) => option?.orgname || ""}
                            isOptionEqualToValue={(option, value) =>
                                option?.orgid === value?.orgid
                            }
                            fullWidth
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Company Name"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        /></Grid>
                    <Grid item xs={1} sm={2} md={3}>
                        <Button
                            component="label"
                            variant="contained"
                            startIcon={<CloudUploadIcon />}
                        >
                            Upload file
                            <VisuallyHiddenInput type="file" onChange={handleFileUpload} accept=".txt,.doc,.docx,.abap" />
                        </Button>&nbsp;&nbsp;
                        {fileName && (
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<DeleteIcon />}
                                onClick={handleDelete}
                            >
                                Delete
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Box>
            {fileName && (
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Selected File: {fileName}
                </Typography>
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* File Content Accordion */}
                <Accordion defaultExpanded elevation={3}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', pr: 2 }}>
                            <Typography variant="h6">
                                File Content{fileName ? `: ${fileName}` : ""}
                            </Typography>
                            {fileContent && (
                                <Button
                                    size="small"
                                    color='success'
                                    variant='contained'
                                    startIcon={<DownloadIcon />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(fileContent, `${fileName}.txt`);
                                    }}
                                />
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ height: '50vh', display: 'flex', flexDirection: 'column' }}>
                        <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            value={fileContent}
                            onChange={(e) => setfileContent(e.target.value)}
                            placeholder="File content will appear here... you can also edit it."
                            sx={{
                                flexGrow: 1,
                                '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start' },
                                '& .MuiInputBase-input': {
                                    height: '100% !important',
                                    overflow: 'auto !important',
                                    fontFamily: "'Roboto Mono', 'Courier New', monospace",
                                    fontSize: '1rem',
                                    fontWeight: '600'
                                }
                            }}
                        />
                        {fileContent && (
                            <Box sx={{ mt: 2, textAlign: 'right' }}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleProcessClick}
                                >
                                    Process Content
                                </Button>
                            </Box>
                        )}
                    </AccordionDetails>
                </Accordion>

                {/* Script Details Accordion */}
                <Accordion defaultExpanded elevation={3}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', pr: 2 }}>
                            <Typography variant="h6">
                                Script Details{fileName ? `: testscenario_${fileName}` : ""}
                            </Typography>
                            {scriptDetails && (
                                <Button
                                    size="small"
                                    color='success'
                                    variant='contained'
                                    startIcon={<DownloadIcon />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(scriptDetails, `testscenario_${fileName}.abap`);
                                    }}
                                />
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ height: '50vh', display: 'flex', flexDirection: 'column' }}>
                        <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            value={scriptDetails}
                            onChange={(e) => setScriptDetails(e.target.value)}
                            placeholder="Processed script details will appear here..."
                            InputProps={{
                                readOnly: false,
                            }}
                            sx={{
                                flexGrow: 1,
                                '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start' },
                                '& .MuiInputBase-input': {
                                    height: '100% !important',
                                    overflow: 'auto !important',
                                    fontFamily: "'Roboto Mono', 'Courier New', monospace",
                                    fontSize: '1rem',
                                    fontWeight: '600'
                                }
                            }}
                        />
                    </AccordionDetails>
                </Accordion>

                {/* Unit Test Case Accordion */}
                <Accordion defaultExpanded elevation={3}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', pr: 2 }}>
                            <Typography variant="h6">
                                Unit Test Case{fileName ? `: testcase_${fileName}` : ""}
                            </Typography>
                            {testCase && (
                                <Button
                                    size="small"
                                    color='success'
                                    variant='contained'
                                    startIcon={<DownloadIcon />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(testCase, `testcase_${fileName}.abap`);
                                    }}
                                />
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ height: '50vh', display: 'flex', flexDirection: 'column' }}>
                        <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            value={testCase}
                            onChange={(e) => setTestCase(e.target.value)}
                            placeholder="Unit test case content will appear here..."
                            InputProps={{
                                readOnly: false,
                            }}
                            sx={{
                                flexGrow: 1,
                                '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start' },
                                '& .MuiInputBase-input': {
                                    height: '100% !important',
                                    overflow: 'auto !important',
                                    fontFamily: "'Roboto Mono', 'Courier New', monospace",
                                    fontSize: '1rem',
                                    fontWeight: '600'
                                }
                            }}
                        />
                    </AccordionDetails>
                </Accordion>
            </Box>

            {/* Process Confirmation Dialog */}
            <Dialog
                open={openProcessConfirm}
                onClose={() => !loading && setOpenProcessConfirm(false)}
                disableEscapeKeyDown={loading}
            >
                <DialogTitle>Confirm Execution</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to process the modified content for <strong>{fileName}</strong>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenProcessConfirm(false)} color="error" disabled={loading}>Cancel</Button>
                    <Button
                        onClick={handleConfirmProcess}
                        color="success"
                        variant="contained"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {loading ? "Processing..." : "Confirm & Run"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Test_Script_Creation;